import { getBootstrapData } from "@swa-ui/bootstrap";

let carLocationCache;

/**
 * getAllCarLocations
 *
 * Return value: array of all car location info.
 */

export const getAllCarLocations = () => getBootstrapData("car/car-locations-data");

const buildCarLocationCache = () => {
  carLocationCache = getAllCarLocations().reduce((cache, locationInfo) => {
    cache[locationInfo.id] = locationInfo;
    cache[locationInfo.displayName] = locationInfo;

    return cache;
  }, {});
};

/**
 * getCarLocation
 *
 * Parameter Example: 'DAL'
 * Return value: Car Location info for given ID. 'undefined' will be return if ID is invalid.
 */
export const getCarLocation = (carLocationCode) => {
  if (!carLocationCache) {
    buildCarLocationCache();
  }

  return carLocationCache[carLocationCode];
};

/**
 * getCarLocationName outputs the display name from a given airport code.
 *
 * Parameter example: 'ABQ'
 * Return value: Albuquerque, NM - ABQ
 *
 */

export const getCarLocationName = (carLocationCode) => {
  const carLocation = getCarLocation(carLocationCode);

  return carLocation ? carLocation.displayName : "";
};

/**
 * getCarLocationForName returns the car location info for the given location display name.
 *
 * Parameter example: 'Albuquerque, NM - ABQ'
 * Return value: car location info
 *
 */
export const getCarLocationForName = (displayName) => getCarLocation(displayName);

/**
 * getCarLocationStationName outputs the station name from a given car location airport code.
 *
 * Parameter example: 'ABQ'
 * Return value: Albuquerque
 *
 */

export const getCarLocationStationName = (carLocationCode) => {
  const carLocation = getCarLocation(carLocationCode);

  return carLocation ? carLocation.stationName : "";
};
